import { useParams } from 'react-router-dom';
import { CurriculumOverviewTable } from '../../../../../components/Curricula/Tables/CurriculumOverviewTable';

export const CurriculumSubjectSubpage = () => {
  const { curriculumUuid, subjectUuid } = useParams();

  return <CurriculumOverviewTable curriculumUuid={curriculumUuid ?? ''} subjectUuid={subjectUuid} />;
};
